import _classCallCheck from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _toConsumableArray from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import remarkFrontmatter from 'remark-frontmatter';
import remarkGFM from 'remark-gfm';
import remarkParse from 'remark-parse';
import unified from 'unified';
import * as Yaml from '@stoplight/yaml';
import { visit, SKIP } from 'unist-util-visit';
import { __rest } from 'tslib';
import GithubSlugger from 'github-slugger';
import { toString } from 'mdast-util-to-string';
import { whitespace } from 'hast-util-whitespace';
import remarkStringify from 'remark-stringify';
import * as types from '@stoplight/types';
import _get from 'lodash/get.js';
import _pullAt from 'lodash/pullAt.js';
import _set from 'lodash/set.js';
import _toPath from 'lodash/toPath.js';
import _unset from 'lodash/unset.js';
import { select } from 'unist-util-select';
import _truncate from 'lodash/truncate.js';
var hast = /*#__PURE__*/Object.freeze({
  __proto__: null
});
var mdast = /*#__PURE__*/Object.freeze({
  __proto__: null
});
var parse$2 = Yaml.parse;

var smdAnnotations = function smdAnnotations() {
  return function transform($root) {
    var root = $root;
    var nodes = root.children;
    var processed = [];
    var inTab = false;
    var tabPlaceholder = {
      type: 'tabs',
      data: {
        hName: 'tabs'
      },
      children: [{
        type: 'tab',
        data: {
          hName: 'tab'
        },
        children: []
      }]
    };

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];

      if ('children' in node) {
        node.children = transform(node).children;
      }

      var _getNextNode = getNextNode(nodes, i),
          _getNextNode2 = _slicedToArray(_getNextNode, 2),
          skipped = _getNextNode2[0],
          next = _getNextNode2[1];

      var anno = captureAnnotations(node);

      if ('type' in anno) {
        var type = anno.type;

        if (type === 'tab') {
          var _tabPlaceholder = tabPlaceholder,
              children = _tabPlaceholder.children;

          if (inTab && tabPlaceholder) {
            children.push({
              type: 'tab',
              data: {
                hName: 'tab'
              },
              children: []
            });
          } else {
            inTab = true;
          }

          if (Object.keys(anno).length > 0) {
            Object.assign(children[children.length - 1].data, {
              hProperties: normalizeAnnotationsForHast(anno)
            });
          }

          tabPlaceholder.children = children;
          continue;
        } else if (type === 'tab-end') {
          processed.push(tabPlaceholder);
          inTab = false;
          tabPlaceholder = {
            type: 'tabs',
            data: {
              hName: 'tabs'
            },
            children: [{
              type: 'tab',
              data: {
                hName: 'tab'
              },
              children: []
            }]
          };
          continue;
        }
      }

      var _root = processed;

      if (inTab) {
        var size = tabPlaceholder.children.length;

        if (tabPlaceholder.children[size - 1]) {
          _root = tabPlaceholder.children[size - 1].children;
        } else {
          continue;
        }
      }

      if (Object.keys(anno).length > 0 && next) {
        _root.push(processNode(next, anno));

        i += skipped;
      } else {
        _root.push(processNode(node));
      }
    }

    return Object.assign(Object.assign({}, root), {
      children: processed
    });
  };
};

function captureAnnotations(node) {
  if (!(node === null || node === void 0 ? void 0 : node.value)) return {};

  if (node.type === 'mdxFlowExpression' && node.value.startsWith('/*') && node.value.endsWith('*/')) {
    var raw = node.value.substr('/*'.length, node.value.length - '*/'.length - '/*'.length).trim();

    try {
      var contents = parse$2(raw);

      if (contents && typeof contents === 'object') {
        for (var key in contents) {
          if (typeof contents[key] === 'string') {
            var escapedContent = contents[key].replace('"', '%22');
            contents[key] = escapedContent;
          }
        }

        return contents;
      }
    } catch (error) {
      console.error("Markdown.captureAnnotations parse YAML error: ".concat(String(error)), error);
    }
  } else if (node.type === 'html' && isHTMLComment(node.value)) {
    var _raw = node.value.slice(node.value.indexOf('<!--') + 4, node.value.lastIndexOf('-->')).trim();

    try {
      var _contents = parse$2(_raw);

      if (_contents && typeof _contents === 'object') {
        return _contents;
      }
    } catch (error) {}
  }

  return {};
}

function processNode(node, annotations) {
  if (annotations) {
    return Object.assign(Object.assign({}, node), {
      annotations: annotations,
      data: Object.assign(Object.assign({}, node.data || {}), {
        hProperties: normalizeAnnotationsForHast(annotations)
      })
    });
  }

  return node;
}

function normalizeAnnotationsForHast(annotations) {
  if (!annotations) return annotations;
  var cleaned = {};

  for (var key in annotations) {
    var annotation = annotations[key];

    if (typeof annotation === 'boolean') {
      cleaned[key] = String(annotation);
    } else {
      cleaned[key] = annotation;
    }
  }

  return cleaned;
}

function isHTMLComment(value) {
  if (typeof value !== 'string') return false;
  var trimmedValue = value.trim();
  return trimmedValue.startsWith('<!--') && trimmedValue.endsWith('-->');
}

function isEmptyNode(node) {
  return node.type === 'text' && String(node.value).trim().length === 0;
}

function getNextNode(nodes, pos) {
  var next = null;
  var i = pos + 1;

  while (i < nodes.length && (next === null || isEmptyNode(next))) {
    next = nodes[i];
    i++;
  }

  return [i - pos - 1, next];
}

var blockquoteMdast2Hast = function blockquoteMdast2Hast() {
  return function transform(root) {
    visit(root, 'blockquote', function (node) {
      var data = node.data || (node.data = {});
      var annotations = node.annotations || {};
      data.hProperties = annotations;
    });
  };
};

var inlineCodeMdast2Hast = function inlineCodeMdast2Hast() {
  return function transform(root) {
    visit(root, 'inlineCode', function (node) {
      var data = node.data || (node.data = {});
      data.hProperties = {
        inline: 'true'
      };
    });
  };
};

var smdCode = function smdCode() {
  return function transform(root) {
    var sequentialCodeBlocks = [];
    var lastIndex = -1;
    var lastParent;
    var groupings = [];
    visit(root, 'code', function (node, index, parent) {
      var _a = parseMeta(node.meta),
          metaTitle = _a.title,
          metaProps = __rest(_a, ["title"]);

      var annotations = Object.assign({}, metaProps, node.annotations);
      var title = annotations.title || metaTitle;

      if (title) {
        annotations = Object.assign({
          title: title
        }, annotations);
      }

      handleLegacyAnnotations(annotations);
      node.annotations = annotations;
      var data = node.data || (node.data = {});
      data.hProperties = Object.assign(Object.assign({
        lang: node.lang
      }, node.annotations), data.hProperties || {});
      var lastCodeBlock = sequentialCodeBlocks[sequentialCodeBlocks.length - 1];

      if (!lastCodeBlock || lastIndex === index - 1 && lastParent === parent) {
        lastIndex = index;
        lastParent = parent;
        sequentialCodeBlocks.push(node);
      } else {
        addCodeGrouping(groupings, lastParent, lastIndex, sequentialCodeBlocks);
        lastIndex = index;
        lastParent = parent;
        sequentialCodeBlocks = [node];
      }
    });
    addCodeGrouping(groupings, lastParent, lastIndex, sequentialCodeBlocks);
    var removed = new Map();

    for (var _i = 0, _groupings = groupings; _i < _groupings.length; _i++) {
      var group = _groupings[_i];

      if (!removed.get(group.parent)) {
        removed.set(group.parent, 0);
      }

      var removeCount = removed.get(group.parent);
      group.parent.children.splice(group.startIndex - removeCount, group.numCodeBlocks, group.codeGroup);
      removed.set(group.parent, removeCount + group.numCodeBlocks - 1);
    }
  };
};

var highlightLinesRangeRegex = /{([\d,-]+)}/;
var metaKeyValPairMatcher = /(\S+)\s*=\s*(\"?)([^"]*)(\2|\s|$)/g;

function parseMeta(metastring) {
  var props = {};
  if (!metastring) return props;
  var metaWithoutKeyValPairs = metastring;
  var keyValPair;

  while ((keyValPair = metaKeyValPairMatcher.exec(metastring)) !== null) {
    props[keyValPair[1]] = keyValPair[3];
    metaWithoutKeyValPairs = metaWithoutKeyValPairs.replace(keyValPair[0], '');
  }

  var booleanProps = metaWithoutKeyValPairs.split(' ');

  var _iterator = _createForOfIteratorHelper(booleanProps),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var booleanProp = _step.value;
      var highlightLinesMatch = booleanProp.match(highlightLinesRangeRegex);

      if (highlightLinesMatch) {
        props.highlightLines = highlightLinesMatch[1];
      } else if (booleanProp) {
        props[booleanProp] = 'true';
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return props;
}

function addCodeGrouping(groupings, parent, lastIndex, children) {
  if (children.length <= 1) return;
  var numCodeBlocks = children.length;
  var codeGroup = {
    type: 'codegroup',
    data: {
      hName: 'codegroup'
    },
    children: children
  };
  groupings.push({
    codeGroup: codeGroup,
    parent: parent,
    startIndex: lastIndex - (numCodeBlocks - 1),
    numCodeBlocks: numCodeBlocks
  });
}

function handleLegacyAnnotations(annotations) {
  if (!annotations) return;

  if (annotations.hasOwnProperty('type')) {
    var type = annotations.type;

    if (type === 'json_schema') {
      annotations.jsonSchema = 'true';
    } else {
      annotations[type] = 'true';
    }

    delete annotations.type;
  }

  if (annotations.hasOwnProperty('json_schema')) {
    annotations.jsonSchema = 'true';
    delete annotations.json_schema;
  }
}

var inlineImages = function inlineImages() {
  return function transformer(tree) {
    visit(tree, ['image', 'imageReference'], function (node, index, parent) {
      var _a, _b;

      if (!parent) return;

      if (applicable$1(parent)) {
        var data = (_a = node.data) !== null && _a !== void 0 ? _a : node.data = {};
        var props = (_b = data.hProperties) !== null && _b !== void 0 ? _b : data.hProperties = {};
        data.inline = true;
        props.inline = 'true';
      }

      return;
    });
  };
};

function applicable$1(node) {
  if (node.type === 'link' || node.type === 'linkReference') return true;
  if (node.type === 'paragraph' && node.children.length > 1) return true;
  return false;
}

var parse$1 = Yaml.parse;

var resolveCodeBlocks = function resolveCodeBlocks(opts) {
  var resolver = opts === null || opts === void 0 ? void 0 : opts.resolver;
  if (!resolver) return;
  return /*#__PURE__*/function () {
    var _transformer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(tree, _file) {
      var _a, _b, codes, promises, _loop, _i2, _codes, _ret;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              codes = [];
              promises = [];
              visit(tree, 'code', function (node, index, parent) {
                codes.push({
                  node: node,
                  index: index,
                  parent: parent
                });
              });

              _loop = function _loop() {
                var node = _codes[_i2].node;
                if (typeof node.value !== 'string') return "continue";
                if (!((_a = node.annotations) === null || _a === void 0 ? void 0 : _a.jsonSchema) && !((_b = node.annotations) === null || _b === void 0 ? void 0 : _b.http)) return "continue";

                try {
                  promises.push(resolver(node, parse$1(node.value)).then(function (resolved) {
                    node.resolved = resolved;
                  }).catch(function () {
                    node.resolved = null;
                  }));
                } catch (_c) {
                  node.resolved = null;
                }
              };

              _i2 = 0, _codes = codes;

            case 5:
              if (!(_i2 < _codes.length)) {
                _context.next = 12;
                break;
              }

              _ret = _loop();

              if (!(_ret === "continue")) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("continue", 9);

            case 9:
              _i2++;
              _context.next = 5;
              break;

            case 12:
              if (!promises.length) {
                _context.next = 15;
                break;
              }

              _context.next = 15;
              return Promise.all(promises);

            case 15:
              return _context.abrupt("return", tree);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function transformer(_x, _x2) {
      return _transformer.apply(this, arguments);
    }

    return transformer;
  }();
};

var slugs = new GithubSlugger();

var slug = function slug() {
  return function transformer(ast) {
    slugs.reset();
    visit(ast, 'heading', function (node) {
      var _a, _b;

      var data = (_a = node.data) !== null && _a !== void 0 ? _a : node.data = {};
      var props = (_b = data.hProperties) !== null && _b !== void 0 ? _b : data.hProperties = {};
      var id = props.id;
      id = id ? slugs.slug(id, true) : slugs.slug(toString(node));
      data.id = id;
      props.id = id;
    });
  };
};

var unwrapImages = function unwrapImages() {
  return function transformer(tree) {
    visit(tree, 'paragraph', function (node, index, parent) {
      if (!index) return;

      if (applicable(node)) {
        var _parent$children;

        parent === null || parent === void 0 ? void 0 : (_parent$children = parent.children).splice.apply(_parent$children, [index, 1].concat(_toConsumableArray(node.children)));
        return [SKIP, index];
      }

      return;
    });
  };
};

function applicable(node, inLink) {
  var image = null;
  var children = node.children;
  var length = children.length;
  var index = -1;
  var child;
  var linkResult;
  var nonwhitespaceChildren = 0;

  while (++index < length) {
    child = children[index];
    var isWhitespace = whitespace(child);
    if (!isWhitespace) nonwhitespaceChildren++;
    if (nonwhitespaceChildren > 1) return false;
    if (isWhitespace) ;else if (child.type === 'image' || child.type === 'imageReference') {
      image = true;
    } else if (!inLink && (child.type === 'link' || child.type === 'linkReference')) {
      linkResult = applicable(child, true);

      if (linkResult === false) {
        return false;
      }

      if (linkResult === true) {
        image = true;
      }
    } else {
      return false;
    }
  }

  return image;
}

var blockStart = /\[block:([A-Za-z]+)\][^\S\n]*(?=\n)/g;
var blockEnd = /\[\/block\][^\S\n]*(?=\n)/g;

var replaceThirdPartyBlocks = function replaceThirdPartyBlocks(input) {
  return input.toString().replace(blockStart, '```block_$1').replace(blockEnd, '```');
};

var remarkParsePreset = {
  plugins: [[remarkFrontmatter, ['yaml']], remarkGFM, slug, unwrapImages, smdAnnotations, smdCode, inlineImages, inlineCodeMdast2Hast, blockquoteMdast2Hast],
  settings: {}
};
var defaultProcessor$1 = unified().use(remarkParse).use(remarkParsePreset);

var parse = function parse(input) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var processor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultProcessor$1;
  var markdown = replaceThirdPartyBlocks(input);
  var processorInstance = processor().data('settings', Object.assign({}, remarkParsePreset.settings, opts.settings)).use(opts.remarkPlugins || []);
  return processorInstance.runSync(processorInstance.parse(markdown));
};

var parseAsync = function parseAsync(input) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var processor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultProcessor$1;

  var _a;

  var markdown = replaceThirdPartyBlocks(input);
  var processorInstance = processor().data('settings', Object.assign({}, remarkParsePreset.settings, opts.settings)).use(resolveCodeBlocks, {
    resolver: (_a = opts.settings) === null || _a === void 0 ? void 0 : _a.resolver
  }).use(opts.remarkPlugins || []);
  return processorInstance.run(processorInstance.parse(markdown));
};
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

/**
 * Results cache
 */


var res = '';
var cache;
/**
 * Expose `repeat`
 */

var repeatString = repeat$2;
/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */

function repeat$2(str, num) {
  if (typeof str !== 'string') {
    throw new TypeError('expected a string');
  } // cover common, quick use cases


  if (num === 1) return str;
  if (num === 2) return str + str;
  var max = str.length * num;

  if (cache !== str || typeof cache === 'undefined') {
    cache = str;
    res = '';
  } else if (res.length >= max) {
    return res.substr(0, max);
  }

  while (max > res.length && num > 1) {
    if (num & 1) {
      res += str;
    }

    num >>= 1;
    str += str;
  }

  res += str;
  res = res.substr(0, max);
  return res;
}

var containerFlow = flow$1;
var repeat$1 = repeatString;

function flow$1(parent, context) {
  var children = parent.children || [];
  var results = [];
  var index = -1;
  var child;

  while (++index < children.length) {
    child = children[index];
    results.push(context.handle(child, parent, context, {
      before: '\n',
      after: '\n'
    }));

    if (index + 1 < children.length) {
      results.push(between(child, children[index + 1]));
    }
  }

  return results.join('');

  function between(left, right) {
    var index = -1;
    var result;

    while (++index < context.join.length) {
      result = context.join[index](left, right, parent, context);

      if (result === true || result === 1) {
        break;
      }

      if (typeof result === 'number') {
        return repeat$1('\n', 1 + Number(result));
      }

      if (result === false) {
        return '\n\n<!---->\n\n';
      }
    }

    return '\n\n';
  }
}

var indentLines_1 = indentLines$2;
var eol = /\r?\n|\r/g;

function indentLines$2(value, map) {
  var result = [];
  var start = 0;
  var line = 0;
  var match;

  while (match = eol.exec(value)) {
    one(value.slice(start, match.index));
    result.push(match[0]);
    start = match.index + match[0].length;
    line++;
  }

  one(value.slice(start));
  return result.join('');

  function one(value) {
    result.push(map(value, line, !value));
  }
}

var blockquote_1 = blockquote;
var flow = containerFlow;
var indentLines$1 = indentLines_1;

function blockquote(node, _, context) {
  var exit = context.enter('blockquote');
  var value = indentLines$1(flow(node, context), map$1);
  exit();
  return value;
}

function map$1(line, index, blank) {
  return '>' + (blank ? '' : ' ') + line;
}

var safeStringify$3 = Yaml.safeStringify;

var blockquoteHandler = function blockquoteHandler(node, _, context) {
  var _a;

  var annotations = Object.assign(Object.assign({}, node.annotations), (_a = node.data) === null || _a === void 0 ? void 0 : _a.hProperties);
  var value = blockquote_1(node, _, context);

  if (Object.keys(annotations).length) {
    return "<!-- ".concat(safeStringify$3(annotations, {
      skipInvalid: true
    }).trim(), " -->\n\n").concat(value);
  }

  return value;
};

var longestStreak_1 = longestStreak; // Get the count of the longest repeating streak of `character` in `value`.

function longestStreak(value, character) {
  var count = 0;
  var maximum = 0;
  var expected;
  var index;

  if (typeof character !== 'string' || character.length !== 1) {
    throw new Error('Expected character');
  }

  value = String(value);
  index = value.indexOf(character);
  expected = index;

  while (index !== -1) {
    count++;

    if (index === expected) {
      if (count > maximum) {
        maximum = count;
      }
    } else {
      count = 1;
    }

    expected = index + 1;
    index = value.indexOf(character, expected);
  }

  return maximum;
}

var formatCodeAsIndented_1 = formatCodeAsIndented$1;

function formatCodeAsIndented$1(node, context) {
  return !context.options.fences && node.value && // If there’s no info…
  !node.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(node.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value);
}

var checkFence_1 = checkFence$1;

function checkFence$1(context) {
  var marker = context.options.fence || '`';

  if (marker !== '`' && marker !== '~') {
    throw new Error('Cannot serialize code with `' + marker + '` for `options.fence`, expected `` ` `` or `~`');
  }

  return marker;
}

var patternCompile_1 = patternCompile$1;

function patternCompile$1(pattern) {
  var before;
  var after;

  if (!pattern._compiled) {
    before = pattern.before ? '(?:' + pattern.before + ')' : '';
    after = pattern.after ? '(?:' + pattern.after + ')' : '';

    if (pattern.atBreak) {
      before = '[\\r\\n][\\t ]*' + before;
    }

    pattern._compiled = new RegExp((before ? '(' + before + ')' : '') + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? '\\' : '') + pattern.character + (after || ''), 'g');
  }

  return pattern._compiled;
}

var patternInScope_1 = patternInScope$1;

function patternInScope$1(stack, pattern) {
  return listInScope(stack, pattern.inConstruct, true) && !listInScope(stack, pattern.notInConstruct);
}

function listInScope(stack, list, none) {
  var index;

  if (!list) {
    return none;
  }

  if (typeof list === 'string') {
    list = [list];
  }

  index = -1;

  while (++index < list.length) {
    if (stack.indexOf(list[index]) !== -1) {
      return true;
    }
  }

  return false;
}

var safe_1 = safe$1;
var patternCompile = patternCompile_1;
var patternInScope = patternInScope_1;

function safe$1(context, input, config) {
  var value = (config.before || '') + (input || '') + (config.after || '');
  var positions = [];
  var result = [];
  var infos = {};
  var index = -1;
  var before;
  var after;
  var position;
  var pattern;
  var expression;
  var match;
  var start;
  var end;

  while (++index < context.unsafe.length) {
    pattern = context.unsafe[index];

    if (!patternInScope(context.stack, pattern)) {
      continue;
    }

    expression = patternCompile(pattern);

    while (match = expression.exec(value)) {
      before = 'before' in pattern || pattern.atBreak;
      after = 'after' in pattern;
      position = match.index + (before ? match[1].length : 0);

      if (positions.indexOf(position) === -1) {
        positions.push(position);
        infos[position] = {
          before: before,
          after: after
        };
      } else {
        if (infos[position].before && !before) {
          infos[position].before = false;
        }

        if (infos[position].after && !after) {
          infos[position].after = false;
        }
      }
    }
  }

  positions.sort(numerical);
  start = config.before ? config.before.length : 0;
  end = value.length - (config.after ? config.after.length : 0);
  index = -1;

  while (++index < positions.length) {
    position = positions[index];

    if ( // Character before or after matched:
    position < start || position >= end) {
      continue;
    } // If this character is supposed to be escaped because it has a condition on
    // the next character, and the next character is definitly being escaped,
    // then skip this escape.


    if (position + 1 < end && positions[index + 1] === position + 1 && infos[position].after && !infos[position + 1].before && !infos[position + 1].after) {
      continue;
    }

    if (start !== position) {
      // If we have to use a character reference, an ampersand would be more
      // correct, but as backslashes only care about punctuation, either will
      // do the trick
      result.push(escapeBackslashes(value.slice(start, position), '\\'));
    }

    start = position;

    if (/[!-/:-@[-`{-~]/.test(value.charAt(position)) && (!config.encode || config.encode.indexOf(value.charAt(position)) === -1)) {
      // Character escape.
      result.push('\\');
    } else {
      // Character reference.
      result.push('&#x' + value.charCodeAt(position).toString(16).toUpperCase() + ';');
      start++;
    }
  }

  result.push(escapeBackslashes(value.slice(start, end), config.after));
  return result.join('');
}

function numerical(a, b) {
  return a - b;
}

function escapeBackslashes(value, after) {
  var expression = /\\(?=[!-/:-@[-`{-~])/g;
  var positions = [];
  var results = [];
  var index = -1;
  var start = 0;
  var whole = value + after;
  var match;

  while (match = expression.exec(whole)) {
    positions.push(match.index);
  }

  while (++index < positions.length) {
    if (start !== positions[index]) {
      results.push(value.slice(start, positions[index]));
    }

    results.push('\\');
    start = positions[index];
  }

  results.push(value.slice(start));
  return results.join('');
}

var code_1 = code;
var repeat = repeatString;
var streak = longestStreak_1;
var formatCodeAsIndented = formatCodeAsIndented_1;
var checkFence = checkFence_1;
var indentLines = indentLines_1;
var safe = safe_1;

function code(node, _, context) {
  var marker = checkFence(context);
  var raw = node.value || '';
  var suffix = marker === '`' ? 'GraveAccent' : 'Tilde';
  var value;
  var sequence;
  var exit;
  var subexit;

  if (formatCodeAsIndented(node, context)) {
    exit = context.enter('codeIndented');
    value = indentLines(raw, map);
  } else {
    sequence = repeat(marker, Math.max(streak(raw, marker) + 1, 3));
    exit = context.enter('codeFenced');
    value = sequence;

    if (node.lang) {
      subexit = context.enter('codeFencedLang' + suffix);
      value += safe(context, node.lang, {
        before: '`',
        after: ' ',
        encode: ['`']
      });
      subexit();
    }

    if (node.lang && node.meta) {
      subexit = context.enter('codeFencedMeta' + suffix);
      value += ' ' + safe(context, node.meta, {
        before: ' ',
        after: '\n',
        encode: ['`']
      });
      subexit();
    }

    value += '\n';

    if (raw) {
      value += raw + '\n';
    }

    value += sequence;
  }

  exit();
  return value;
}

function map(line, _, blank) {
  return (blank ? '' : '    ') + line;
}

var safeStringify$2 = Yaml.safeStringify;

var codeHandler = function codeHandler(node, _, context) {
  var _a;

  var _b = ((_a = node.data) === null || _a === void 0 ? void 0 : _a.hProperties) || {},
      annotations = __rest(_b, ["lang", "meta"]);

  if (node.resolved) {
    node.value = node.lang === 'json' ? JSON.stringify(node.resolved, null, 2) : safeStringify$2(node.resolved, {
      indent: 2
    });
  }

  var metaProps = computeMetaProps(Object.assign(Object.assign({}, node.annotations), annotations));

  if (metaProps.length) {
    node.meta = metaProps.join(' ');
  }

  return code_1(node, _, context);
};

function computeMetaProps(annotations) {
  var metaProps = [];

  if (Object.keys(annotations).length) {
    for (var key in annotations) {
      var annotationVal = annotations[key];

      if (typeof annotationVal === 'boolean' || annotationVal === 'true' || annotationVal === 'false') {
        if (annotationVal && annotationVal !== 'false') {
          metaProps.push(key);
        }

        continue;
      } else if (key === 'type') {
        if (annotationVal === 'json_schema') {
          metaProps.push('jsonSchema');
        }
      } else if (key === 'highlightLines') {
        if (Array.isArray(annotationVal)) {
          var rangeVals = [];

          var _iterator2 = _createForOfIteratorHelper(annotationVal),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var val = _step2.value;

              if (Array.isArray(val)) {
                rangeVals.push("".concat(val[0], "-").concat(val[1]));
              } else {
                rangeVals.push(val);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          if (rangeVals.length) {
            metaProps.push("{".concat(rangeVals.join(','), "}"));
          }
        } else {
          metaProps.push("{".concat(annotationVal, "}"));
        }
      } else {
        metaProps.push("".concat(key, "=\"").concat(annotationVal, "\""));
      }
    }
  }

  return _toConsumableArray(new Set(metaProps));
}

var codeGroupHandler = function codeGroupHandler(node, _, context) {
  var exit = context.enter('codegroup');
  var value = containerFlow(node, context);
  exit();
  return value;
};

var safeStringify$1 = Yaml.safeStringify;

var tabsHandler = function tabsHandler(node, _, context) {
  var exit = context.enter('tabs');
  var value = containerFlow(node, context);
  exit();
  return "".concat(value, "\n\n<!-- type: tab-end -->");
};

var tabHandler = function tabHandler(node, _, context) {
  var _a;

  var exit = context.enter('tab');

  var _b = ((_a = node.data) === null || _a === void 0 ? void 0 : _a.hProperties) || {},
      annotations = __rest(_b, ["type"]);

  var value = containerFlow(node, context);
  exit();
  return "<!--\ntype: tab\n".concat(safeStringify$1(Object.assign(Object.assign({}, node.annotations), annotations), {
    skipInvalid: true
  }).trim(), "\n-->\n\n").concat(value);
};

var remarkStringifyPreset = {
  plugins: [[remarkFrontmatter, ['yaml']], remarkGFM],
  settings: {
    bullet: '-',
    emphasis: '_',
    fences: true,
    incrementListMarker: true,
    listItemIndent: 'one',
    rule: '-',
    handlers: {
      blockquote: blockquoteHandler,
      code: codeHandler,
      tabs: tabsHandler,
      tab: tabHandler,
      codegroup: codeGroupHandler
    }
  }
};
var defaultProcessor = unified().use(remarkStringify).use(remarkStringifyPreset);

var _stringify = function stringify(tree) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var processor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultProcessor;
  var processorInstance = processor().data('settings', Object.assign({}, remarkStringifyPreset.settings, opts.settings)).use(opts.remarkPlugins || []);
  return processorInstance.stringify(processorInstance.runSync(tree));
};

var Reader = /*#__PURE__*/function () {
  function Reader() {
    _classCallCheck(this, Reader);
  }

  _createClass(Reader, [{
    key: "fromLang",
    value: function fromLang(raw) {
      return parse(raw);
    }
  }, {
    key: "toLang",
    value: function toLang(data) {
      return _stringify(data);
    }
  }]);

  return Reader;
}();

var Builder = /*#__PURE__*/function () {
  function Builder() {
    var reader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Reader();

    _classCallCheck(this, Builder);

    this.reader = reader;
    this.root = {
      type: 'root',
      children: []
    };
  }

  _createClass(Builder, [{
    key: "addMarkdown",
    value: function addMarkdown(markdown) {
      var _this$root$children;

      (_this$root$children = this.root.children).push.apply(_this$root$children, _toConsumableArray(this.reader.fromLang(markdown).children));

      return this;
    }
  }, {
    key: "addChild",
    value: function addChild(node) {
      this.root.children.push(node);
      return this;
    }
  }, {
    key: "toString",
    value: function toString() {
      return _stringify(this.root);
    }
  }]);

  return Builder;
}();

var parseWithPointers = function parseWithPointers(input) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var processor = arguments.length > 2 ? arguments[2] : undefined;
  var tree = parse(input, opts, processor);
  return {
    data: tree,
    diagnostics: [],
    ast: tree,
    lineMap: undefined
  };
};

var parseYaml = Yaml.parseWithPointers,
    safeStringify = Yaml.safeStringify;
var DiagnosticSeverity = types.DiagnosticSeverity;

var isError = function isError(_ref) {
  var severity = _ref.severity;
  return severity === DiagnosticSeverity.Error;
};

var safeParse = function safeParse(value) {
  try {
    var _parseYaml = parseYaml(String(value)),
        data = _parseYaml.data,
        diagnostics = _parseYaml.diagnostics;

    if (data === void 0 || diagnostics.length > 0 && diagnostics.some(isError)) {
      return {};
    }

    return data;
  } catch (_a) {
    return {};
  }
};

var Frontmatter = /*#__PURE__*/function () {
  function Frontmatter(data) {
    var mutate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, Frontmatter);

    var root = typeof data === 'string' ? parseWithPointers(data).data : mutate ? data : JSON.parse(JSON.stringify(data));

    if (root.type !== 'root') {
      throw new TypeError('Malformed yaml was provided');
    }

    this.document = root;

    if (root.children.length > 0 && root.children[0].type === 'yaml') {
      this.node = root.children[0];
      this.properties = safeParse(this.node.value);
    } else {
      this.node = {
        type: 'yaml',
        value: ''
      };
      this.properties = null;
    }
  }

  _createClass(Frontmatter, [{
    key: "getAll",
    value: function getAll() {
      if (this.properties !== null) {
        return this.properties;
      }
    }
  }, {
    key: "get",
    value: function get(prop) {
      if (this.properties !== null) {
        return _get(this.properties, prop);
      }
    }
  }, {
    key: "set",
    value: function set(prop, value) {
      if (this.properties === null) {
        this.properties = {};
      }

      _set(this.properties, prop, value);

      this.updateDocument();
    }
  }, {
    key: "unset",
    value: function unset(prop) {
      if (this.properties !== null) {
        var path = _toPath(prop);

        var lastSegment = Number(path[path.length - 1]);

        if (!Number.isNaN(lastSegment)) {
          var baseObj = path.length > 1 ? this.get(path.slice(0, path.length - 1)) : this.getAll();

          if (Array.isArray(baseObj)) {
            if (baseObj.length < lastSegment) return;

            _pullAt(baseObj, lastSegment);
          } else {
            _unset(this.properties, prop);
          }
        } else {
          _unset(this.properties, prop);
        }

        this.updateDocument();
      }
    }
  }, {
    key: "stringify",
    value: function stringify() {
      return _stringify(this.document);
    }
  }, {
    key: "updateDocument",
    value: function updateDocument() {
      var children = this.document.children;
      if (!children) return;
      var index = children.indexOf(this.node);
      this.node.value = this.isEmpty ? '' : safeStringify(this.properties, {
        flowLevel: 1,
        indent: 2
      }).trim();

      if (this.isEmpty) {
        if (index !== -1) {
          children.splice(index, 1);
        }
      } else if (index === -1) {
        children.unshift(this.node);
      }
    }
  }, {
    key: "isEmpty",
    get: function get() {
      for (var _ in this.properties) {
        if (Object.hasOwnProperty.call(this.properties, _)) {
          return false;
        }
      }

      return true;
    }
  }], [{
    key: "getFrontmatterBlock",
    value: function getFrontmatterBlock(value) {
      var match = value.match(/^(\s*\n)?---(?:.|[\n\r\u2028\u2029])*?\n---/);
      return match === null ? void 0 : match[0];
    }
  }]);

  return Frontmatter;
}();

var getJsonPathForNode = function getJsonPathForNode(root, node) {
  var path = [];
  findNode(root, node, path);
  return path;
};

function findNode(root, node, path) {
  if (node.position === undefined || root.position === undefined) return;

  if (node.position.start.line === root.position.start.line && node.position.end.line === root.position.end.line && node.position.start.column === root.position.start.column && node.position.end.column === root.position.end.column) {
    return node;
  }

  if (node.position.start.line >= root.position.start.line && node.position.end.line <= root.position.end.line) {
    var children = root.children;

    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; i++) {
        var item = findNode(children[i], node, path);

        if (item) {
          path.unshift('children', i);
          return findNode(item, node, path);
        }
      }
    }
  }

  return;
}

var getJsonPathForPosition = function getJsonPathForPosition(_ref2, position) {
  var ast = _ref2.ast;
  var path = [];
  findNodeAtPosition(ast, position, path);
  return path;
};

function findNodeAtPosition(node, position, path) {
  if (position.line >= node.position.start.line - 1 && position.line <= node.position.end.line - 1) {
    var children = node.children;

    if (Array.isArray(children)) {
      for (var i = children.length - 1; i >= 0; i--) {
        var item = findNodeAtPosition(children[i], position, path);

        if (item && (item.position.start.line !== item.position.end.line || position.character >= item.position.start.column - 1 && position.character <= item.position.end.column - 1)) {
          path.unshift('children', i);
          return findNodeAtPosition(item, position, path);
        }
      }
    }

    return node;
  }

  return;
}

var getLocationForJsonPath = function getLocationForJsonPath(_ref3, path) {
  var ast = _ref3.ast;
  var data = path.length === 0 ? ast : _get(ast, path);
  if (data === void 0) return;
  return {
    range: {
      start: {
        character: data.position.start.column - 1,
        line: data.position.start.line - 1
      },
      end: {
        character: data.position.end.column - 1,
        line: data.position.end.line - 1
      }
    }
  };
};

var getProperty = function getProperty(propName, element, data) {
  var target;

  if (data) {
    try {
      var frontmatter = new Frontmatter(data, true);
      target = frontmatter.get(propName);

      if (element && !target) {
        var elem = select(element, data);

        if (elem) {
          target = toString(elem);
        }
      }
    } catch (e) {
      console.warn("Error getting ".concat(propName, " from markdown document"), e);
    }
  }

  return target;
};

var getSummary = function getSummary(data) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var summary = getProperty('summary', 'paragraph', data);

  if (summary && opts.truncate) {
    summary = _truncate(summary, {
      length: opts.truncate + 3
    });
  }

  return summary;
};

var getTags = function getTags(data) {
  var tags = [];

  if (data) {
    try {
      var frontmatter = new Frontmatter(data, true);
      var dataTags = frontmatter.get('tags');

      if (dataTags && Array.isArray(dataTags)) {
        return dataTags.reduce(function (filteredTags, tag) {
          if (tag && typeof tag === 'string' && tag !== 'undefined' && tag !== 'null') {
            filteredTags.push(String(tag));
          }

          return filteredTags;
        }, []);
      }
    } catch (e) {
      console.warn('Error getting tags from markdown document', e);
    }
  }

  return tags;
};

var getTitle = function getTitle(data) {
  if (typeof data === 'string') {
    return getTitleFromRaw(data);
  } else {
    return getProperty('title', 'heading', data);
  }
};

function getTitleFromRaw(raw) {
  if (!raw) return raw;
  var frontmatterBlock = Frontmatter.getFrontmatterBlock(raw);

  if (frontmatterBlock) {
    var title = new Frontmatter(frontmatterBlock).get('title');

    if (title) {
      return String(title);
    }
  }

  var match = raw === null || raw === void 0 ? void 0 : raw.match(/^(?=(#+))\1(?=(\s*))\2(?=(.*))\3$/m);
  return match ? match[3] : void 0;
}

export { Builder, Frontmatter, hast as HAST, mdast as MDAST, Reader, blockquoteMdast2Hast, getJsonPathForNode, getJsonPathForPosition, getLocationForJsonPath, getProperty, getSummary, getTags, getTitle, inlineCodeMdast2Hast, inlineImages, normalizeAnnotationsForHast, parse, parseAsync, parseWithPointers, remarkParsePreset, resolveCodeBlocks, slug, smdAnnotations, smdCode, _stringify as stringify, unwrapImages };